import { useState } from 'react';
import { Play, X, ZoomIn } from 'lucide-react';
import './Gallery.css';

const categories = ['All', 'Band Members', 'Performances', 'Events', 'Video'];

const galleryItems = [
  // Band Members
  { id:1,  type:'image', src:'/Assets/jimmy-band-jimmy-john-thomas.jpg.jpeg',   title:'Jimmy John Thomas — Lead Vocalist',       cat:'Band Members' },
  { id:2,  type:'image', src:'/Assets/jimmy-band-gaurav-bhatt.jpg.jpeg',         title:'Gaurav Bhatt — Vocalist & Guitarist',     cat:'Band Members' },
  { id:3,  type:'image', src:'/Assets/jimmy-band-raghvendra-mathur.jpg.jpeg',    title:'Raghvendra Mathur — Drums & Octopad',     cat:'Band Members' },
  { id:4,  type:'image', src:'/Assets/jimmy-band-bhavani-shankar-javda.jpg.jpeg',title:'Bhavani Shankar Javda — Rhythmist',       cat:'Band Members' },
  { id:5,  type:'image', src:'/Assets/mainslide-04.jpg.jpeg',     title:'Prakash Gandharv — Keyboard & Guitar',    cat:'Band Members' },

  // Performances / genres
  { id:6,  type:'image', src:'/Assets/p1.jpg.jpeg', title:'Bollywood Night',            cat:'Performances' },
  { id:7,  type:'image', src:'/Assets/p2.jpg.jpeg', title:'English Retro Evening',      cat:'Performances' },
  { id:8,  type:'image', src:'/Assets/p3.jpg.jpeg', title:'Sufi Night',                 cat:'Performances' },
  { id:9,  type:'image', src:'/Assets/p4.jpg.jpeg', title:'Ghazal Evening',             cat:'Performances' },
  { id:10, type:'image', src:'/Assets/p5.jpg.jpeg', title:'Indian Classical',           cat:'Performances' },
  { id:11, type:'image', src:'/Assets/p6.jpg.jpeg', title:'Folk Fusion',                cat:'Performances' },

  // Events
  { id:12, type:'image', src:'/Assets/jimmy-band-jimmy-john-thomas.jpg.jpeg',    title:'Corporate Gala — Jimmy John Thomas',      cat:'Events', style:'tall' },
  { id:13, type:'image', src:'/Assets/jimmy-band-gaurav-bhatt.jpg.jpeg',          title:'Wedding Reception Performance',           cat:'Events' },
  { id:14, type:'image', src:'/Assets/jimmy-band-bhavani-shankar-javda.jpg.jpeg', title:'Birthday Celebration',                    cat:'Events', style:'wide' },
  { id:15, type:'image', src:'/Assets/jimmy-band-raghvendra-mathur.jpg.jpeg',    title:'Family Get Together',                     cat:'Events' },
  { id:16, type:'image', src:'/Assets/mainslide-04.jpg.jpeg',     title:'Anniversary Party',                       cat:'Events' },
  { id:17, type:'image', src:'/Assets/p1.jpg.jpeg',                               title:'Cafe Live Music Night',                   cat:'Events' },
  { id:18, type:'image', src:'/Assets/p3.jpg.jpeg',                               title:'International Tour — UAE',                cat:'Events' },
  { id:19, type:'image', src:'/Assets/p5.jpg.jpeg',                               title:'International Tour — France',             cat:'Events' },

  // Video
  { id:20, type:'video', src:'https://img.youtube.com/vi/jwjZGmhwgLA/hqdefault.jpg', yt:'jwjZGmhwgLA', title:'Jimmy\'z Band Live Concert', cat:'Video' },
  { id:21, type:'video', src:'https://img.youtube.com/vi/jwjZGmhwgLA/mqdefault.jpg', yt:'jwjZGmhwgLA', title:'Live Performance Highlights',  cat:'Video' },
];

export default function Gallery() {
  const [active, setActive] = useState('All');
  const [lightbox, setLightbox] = useState(null);

  const filtered = active === 'All' ? galleryItems : galleryItems.filter(g => g.cat === active);

  return (
    <div className="gallery-page">
      <div className="page-hero">
        <span className="breadcrumb">Home / <span>Events Gallery</span></span>
        <h1>Events Gallery</h1>
      </div>

      <section className="gallery-section">
        <div className="container">

          {/* Filters */}
          <div className="gallery-filters">
            {categories.map(c => (
              <button key={c} className={`filter-btn ${active === c ? 'active' : ''}`} onClick={() => setActive(c)}>
                {c} {active !== 'All' && c === 'All' ? '' : ''}
                <span className="filter-count">
                  {c === 'All' ? galleryItems.length : galleryItems.filter(g=>g.cat===c).length}
                </span>
              </button>
            ))}
          </div>

          {/* Masonry Grid */}
          <div className="gallery-grid">
            {filtered.map((item, i) => (
              <div
                key={item.id}
                className={`gallery-item ${item.style || ''} animate-fadeInUp`}
                style={{ animationDelay: `${(i % 8) * 0.06}s` }}
                onClick={() => setLightbox(item)}
              >
                <img
                  src={item.src}
                  alt={item.title}
                  loading="lazy"
                  onError={e => {
                    e.target.src = `https://via.placeholder.com/400x300/8B0000/ffffff?text=${encodeURIComponent(item.cat)}`;
                  }}
                />
                <div className="gallery-overlay">
                  <div className="gallery-overlay-icons">
                    {item.type === 'video'
                      ? <div className="g-play-btn"><Play size={22} fill="white" /></div>
                      : <div className="g-zoom-btn"><ZoomIn size={20} /></div>
                    }
                  </div>
                  <div className="gallery-caption">
                    <span className="gallery-title">{item.title}</span>
                    <span className="gallery-cat">{item.cat}</span>
                  </div>
                </div>
                {item.type === 'video' && (
                  <div className="video-badge"><Play size={12} fill="white" /> Video</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightbox && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)}><X size={22} /></button>
          <div className="lightbox-content" onClick={e => e.stopPropagation()}>
            {lightbox.type === 'video' ? (
              <iframe
                src={`https://www.youtube.com/embed/${lightbox.yt}?autoplay=1`}
                title={lightbox.title}
                allow="autoplay; fullscreen"
                allowFullScreen
              />
            ) : (
              <img src={lightbox.src} alt={lightbox.title} />
            )}
            <div className="lightbox-caption">
              <h4>{lightbox.title}</h4>
              <span className="badge">{lightbox.cat}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
